import { queryOptions } from '@tanstack/react-query'

import { fetchAdminInvoices } from './admin-invoices-api'

export const adminInvoicesQuery = () =>
  queryOptions({
    queryKey: ['admin-invoices', 'list'],
    queryFn: ({ signal }) => fetchAdminInvoices(signal),
  })
